<template>
  <DatePicker
    v-bind="$attrs"
    :value="value"
    :lang="lang"
    :value-type="valueFormat"
    :class="{ 'has-error': error }"
    @input="$emit('input', $event)"
  >
    <template #icon-calendar>
      <i class="icon-calendar datepicker-icon"></i>
    </template>
  </DatePicker>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/lt';

export default {
  name: 'BaseDatepicker',

  components: {
    DatePicker,
  },

  props: {
    value: {
      type: [String, Date],
      default: '',
    },
    type: {
      type: String,
      default: 'date',
    },
    valueFormat: {
      type: String,
      default: 'YYYY-MM-DD',
    },
    error: {
      type: String,
      default: '',
    },
  },

  computed: {
    lang() {
      return {
        formatLocale: {
          months: this.$t('datepicker.months'),
          monthsShort: this.$t('datepicker.monthsShort'),
          weekdays: this.$t('datepicker.weekdays'),
          weekdaysShort: this.$t('datepicker.weekdaysShort'),
          weekdaysMin: this.$t('datepicker.weekdaysMin'),
        },
      };
    },
  },
};
</script>

<style lang="scss">
$default-color: #000;
$primary-color: #27ae61;

.mx-input:hover,
.mx-input:focus {
  border-color: #d9dee0 !important;
}

.datepicker-icon {
  color: #415e72;
  font-size: 20px;
}

.mx-datepicker {
  width: 100% !important;
}

.mx-datepicker-main {
  font-family: Roboto, sans-serif !important;

  th {
    text-align: center;
  }
}

.mx-calendar-content .cell {
  border-radius: 50%;
}

.mx-icon-clear {
  font-size: 20px !important;
}

.mx-input:disabled,
.mx-input.disabled {
  color: #373a3c !important;
  border-color: #dadee0 !important;
  background-color: #eee !important;
}

@import '~vue2-datepicker/scss/index.scss';
</style>
